import { useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import useSolrSearch from "~/hooks/useSolrSearch";
import { AdvancedSearchContext } from "~/providers/AdvancedSearchProvider";

import DisclosuresList from "../../SearchV3/components/SearchForm/DisclosuresDropdownMenu/DisclosuresList";
import ImageThemes from "./Categories/ImageThemes";
import PageSections from "./Categories/PageSections";
import Years from "./Categories/Years";
import Industries from "./Categories/Industries";
import Companies from "./Categories/Companies";
import ModalCompanies from "./Categories/ModalCompanies";
// import SortBy from "../Categories/SortBy";
import FilterKeyword from "./ListToggle/FilterKeyword";

interface FilterListProps {
    resultType: string | undefined;
}

const FilterList = (props: FilterListProps) => {
    const { resultType } = props;
    const { triggerSearch } = useContext(AdvancedSearchContext);
    const { logSearch } = useSolrSearch("");
    const { t } = useTranslation();

    const isFullDocumentsTab = resultType === "fullDocuments";

    useEffect(() => {
        if (triggerSearch) {
            logSearch();
        }
    }, [triggerSearch]);

    return (
        <div className="h-full w-full border-b border-stone-soft">
            <div className="w-full h-[72px] bg-white flex justify-between items-center px-10">
                {/* Left Section */}
                <div className="flex h-[40px] items-center">
                    <div className="flex items-center h-[40px] z-10 text-sm text-stone-vibrant tracking-[-2%] border-r-2 border-stone-soft leading-5 pr-3">
                        <span className="pr-2">{t("searchForm.searchPartialMsg")}</span>
                        <DisclosuresList className="text-sm" />
                    </div>
                    <div className="ml-4">
                        {resultType === "texts" && <FilterKeyword />}
                        {resultType === "images" && <ImageThemes />}
                        {resultType === "pages" && <PageSections />}

                        {isFullDocumentsTab && <ModalCompanies />}
                    </div>
                </div>

                {/* Right Section */}
                <div className="flex items-center h-16 gap-4 z-10 text-sm text-stone-vibrant tracking-[-2%] leading-5">
                    <span>{t("filterBy")}</span>
                    <Years />

                    {!isFullDocumentsTab && (
                        <>
                            <Industries />
                            <Companies />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FilterList;
